import { BannerCarousel } from "../components/carousel/BannerCarousel";
import { ConcursScroll } from "../components/carousel/ConcursScroll";
import { BlockGrid } from "../components/blocks/BlockGrid";
import { FeatureSection } from "../components/sections/FeatureSection";
import { AgendaSection } from "../components/sections/AgendaSection";
import { EditorialTiles } from "../components/sections/EditorialTiles";
import { BrandStatement } from "../components/sections/BrandStatement";
import { Container } from "../components/ui/Container";
import { LinkButton } from "../components/ui/Button";
import {
	agendaEvents,
	concursCards,
	editorialFeature,
	highlights,
	homeBlocks,
	presentationFeature,
} from "../data";
import "./Home.css";

/**
 * Home: carrossel de destaques, montagem do concurs, mosaico de llibres e as
 * secções de apresentação, agenda e marca. Os dois blocos de destaque trocam
 * de lado entre si, para a página não descer sempre pela mesma coluna.
 */
export function Home() {
	return (
		<div className="home-page">
			{/* Fora do container: carrossel e concurs sangram até as bordas. */}
			<BrandStatement />
			<BannerCarousel highlights={highlights} />

			<ConcursScroll cards={concursCards} />

			<section className="blocks" id="llibres">
				<Container>
					<BlockGrid blocks={homeBlocks} />

					<div className="home__more">
						<LinkButton href="/botiga/" variant="yellow">
							més llibres
						</LinkButton>
					</div>
				</Container>
			</section>

			<Container>
				<FeatureSection feature={editorialFeature} />
				<FeatureSection feature={presentationFeature} />
				<AgendaSection events={agendaEvents} />
				<EditorialTiles />
			</Container>
		</div>
	);
}
